import { createStore } from 'vuex'

import auth from './modules/auth'
import licenseStats from './modules/licenses/license-stats'
import mission from './modules/mission'
import history from './modules/history'
import global from './modules/global'
import organizations from './modules/organizations'

export default createStore({
    modules: {
        auth,
        mission,
        history,
        global,
        licenseStats,
        organizations,
    },
})
